import { getEntity, getFooterData, getHeaderData } from '@api/index'

import { default as normalizePolicy } from '@models/Policy'
import { default as normalizeBreadcrumb } from '@models/Breadcrumb'
import { default as normalizeFooterData } from '@models/Footer'
import { default as normalizeHeaderData } from '@models/Header'
import normalizeMetadata from '@models/Metadata'

import Breadcrumb from '@/molecules/Breadcrumb'
import { SectionBuilder } from '@/organisms'

import Layout from '@/organisms/Layout'

export const getStaticProps = async ({ params }) => {
  const [header, footer, educationalLife] = await Promise.all([
    getHeaderData(),
    getFooterData(),
    getEntity({ entity: 'educationalLife' }),
  ])
  const metadata = normalizeMetadata(educationalLife?.data?.seo)

  return {
    props: {
      metadata,
      breadcrumb: normalizeBreadcrumb([
        { label: 'Di che ramo sei?', href: '/di-che-ramo-sei', role: 'link' },
        { label: 'Educational Vita' },
      ]),
      footer: normalizeFooterData(footer),
      header: normalizeHeaderData(header),
      content: normalizePolicy(educationalLife?.data || {}) || null,
    },
  }
}

const EducationalVita = ({ metadata, header, footer, breadcrumb, content }) => {
  return (
    <Layout
      metadata={metadata}
      headerData={header}
      footerData={footer}
      colorScheme='white'
    >
      <Breadcrumb items={breadcrumb} />
      <SectionBuilder data={content.sections} />
    </Layout>
  )
}

export default EducationalVita
